import React from "react";
import styled, { css } from "styled-components";
import { hot } from "react-hot-loader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
    setClickedEventSegment,
    setSelectedJobpostingID,
    navigateTo,
    setCopyPasteEvent,
    removeEvent,
} from "./actions";
import {
    selectClickedEventSegment,
    selectJobpostingProfile,
    selectIsLocked,canDelete,canCreate,canUpdate
} from "./selectors";
import {
    Edit as EditIcon,
    FileCopy as CopyIcon,
    Clear as ClearIcon,
    Add as AddIcon,
} from "@material-ui/icons";
import { Button, Chip } from "@material-ui/core";

const StyledButton = styled(Button)`
    max-height: 30px;
    min-height: 0px !important;
    max-width: 30px;
    min-width: 0px !important;
    width: 30px;
    height: 30px;
    padding: 0px !important;
    padding-left: 0px !important;
    pointer-events: all;
`;

const moveAnimation = css`
    left: ${(props) => (100 / (props.weekCount * 7)) * props.startIndex}%;
    right: ${(props) =>
        100 -
        (100 / (props.weekCount * 7)) *
            (props.startIndex + props.columnCount)}%;
    top: ${(props) => (100 / props.rowCount) * props.rowIndex}%;
    bottom: ${(props) => 100 - (100 / props.rowCount) * (props.rowIndex + 1)}%;
`;

const EventContainer = styled.div`
    position: absolute;
    z-index: 2;
    border-radius: 8px;
    transition: all ${(props) => props.duration}ms;
    overflow: hidden;
    border: 1px solid white;
    pointer-events: none;

    &.entering {
        opacity: 0;
        ${moveAnimation};
    }
    &.entered {
        opacity: 1;
        ${moveAnimation};
    }
    &.exiting {
        opacity: 0;
        ${moveAnimation};
    }
`;

const EventResizeGrid = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    position: absolute;
    grid-template-rows: 1;
    grid-template-columns: 10px repeat(${(props) => props.columnCount}, auto) 10px;
`;

const pointerEvents = (eventType) => {
    return ({
        matchingRowIndex,
        clickedColumnIndex,
        absoluteColumnIndex,
        type,
        clickedEventSegment,
    }) => {
        if (clickedEventSegment === false) {
            return "all";
        } else if (
            matchingRowIndex === true &&
            clickedColumnIndex === absoluteColumnIndex &&
            type === eventType
        ) {
            return "all";
        } else {
            return "none";
        }
    };
};

const EventResizeHandle = styled.div`
    height: 100%;
    grid-column: ${(props) => props.column};
    background-color: black;
    cursor: ${(props) => {
        if (props.type === "none") {
            return "default";
        }
        if (props.side === "right") {
            return "e-resize";
        } else if (props.side === "left") {
            return "w-resize";
        }
    }};
    width: 10px;
    opacity: 0;
    pointer-events: ${pointerEvents("resize")};
`;

const EventMoveHandle = styled.div`
    height: 100%;
    grid-column: ${(props) => props.column + 1};
    background-color: lightgrey;
    cursor: ${(props) => {
        if (props.type === "none") {
            return "default";
        } else {
            return "move";
        }
    }};
    opacity: 0;
    pointer-events: ${pointerEvents("move")};
`;

const EventFace = styled.div`
    pointer-events: none;
    z-index: 3;
    width: 100%;
    height: 100%;
    background-color: rgba(
        ${(props) => props.colour},
        ${(props) => (props.selected ? 0.74 : 0.2)}
    );
    position: absolute;
    border: 2px solid ${(props) => (props.selected ? "blue" : "black")};
    border-radius: 8px;
    transition: all ${(props) => props.duration}ms;
    display: grid;
    grid-template-rows: 30px 1fr;
    grid-template-columns: 1fr;
`;

const EventInfo = styled.div`
    grid-row: 2;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-rows: min-content;
`;

const JobStyle = css`
    padding: 5px;
    font-size: 0.8em;
    grid-row: ${(props) => props.rowIndex};
`;

const JobTitle = styled.div`
    ${JobStyle}
    grid-column: 1;
    font-weight: bold;
`;
const JobPersonnel = styled.div`
    ${JobStyle}
    grid-column: 2;
`;

const PersonnelRow = ({ jobTitle, jobPersonnel, rowIndex }) => {
    return (
        <>
            <JobTitle rowIndex={rowIndex}>{jobTitle}</JobTitle>
            <JobPersonnel rowIndex={rowIndex}>{jobPersonnel}</JobPersonnel>
        </>
    );
};

const EventHeader = styled.div`
    pointer-events: none;
    grid-row: 1;
    grid-column: 1;
    z-index: 3;
    width: 100%;
    height: 100%;
    background-color: rgba(
        0,
        0,
        0,
        ${(props) => (props.selected ? 0.84 : 0.2)}
    );
    color: ${(props) => (props.selected ? "white" : "black")};
    display: grid;
    font-size: 1em;
    padding-left: 5px;
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 30px 30px;
    grid-template-rows: 1fr;
`;

const HeaderText = styled.div`
    grid-row: 1;
    grid-column: 1;
    overflow: hidden;
`;

const HeaderLink = styled.div`
    grid-row: 1;
    grid-column: ${(props) => props.column};
`;
class Event extends React.Component {
    onDragStart = (e) => {};

    onDragEnd = (e) => {
        this.props.setClickedEventSegment(false);
    };

    onDrag = (e) => {};

    onMouseDown = (type, columnIndex) => {
        const ces = {
            type,
            columnIndex,
            rowIndex: this.props.rowIndex,
            event: this.props.event,
        };

        this.props.setClickedEventSegment(ces);
    };
    getName(item, key) {
        return item.map((e) => e[key]);
    }

    render() {
        const {
            event,
            rowCount,
            duration,
            transitionStatus,
            clickedEventSegment,
            rowIndex,
            eventInfo,
        } = this.props;

        let startIndex = event.startIndex;
        let endIndex = event.endIndex;
        const {
            job_vehicles,
            job_equipment,
            assigned_operatives,
            assigned_supervisor,
            address,
            job_id,
        } = eventInfo;
        if (startIndex < 0) {
            startIndex = 0;
        }

        if (endIndex > this.props.weekCount * 7 - 1) {
            endIndex = this.props.weekCount * 7 - 1;
        }
        let columnCount = endIndex - startIndex + 1;
        columnCount = columnCount === 0 ? 1 : columnCount;

        const commonEventProps = {
            draggable: true,
            matchingRowIndex: clickedEventSegment.rowIndex === rowIndex,
            clickedColumnIndex:
                typeof clickedEventSegment.columnIndex === "undefined"
                    ? false
                    : clickedEventSegment.columnIndex,
            onDragStart: this.onDragStart,
            onDragEnd: this.onDragEnd,
            onDrag: this.onDrag,
            clickedEventSegment,
        };

        const { job_name } = this.props.eventInfo;

        const managerRowStart = 1;

        return (
            <EventContainer
                onMouseDown={() => {
                    this.props.setSelectedJobpostingID(event.uid);
                }}
                weekCount={this.props.weekCount}
                rowCount={rowCount}
                rowIndex={rowIndex}
                startIndex={startIndex}
                endIndex={endIndex}
                columnCount={columnCount}
                duration={duration}
                className={transitionStatus}
                onDoubleClick={() => {
                    this.props.navigateTo(`/job-posting-edit/${event.uid}`);
                }}
            >
                <EventResizeGrid columnCount={columnCount}>
                    <EventResizeHandle
                        {...commonEventProps}
                        column={1}
                        side={"left"}
                        onMouseDown={() => {
                            this.onMouseDown("resizeLeft", startIndex);
                        }}
                        absoluteColumnIndex={startIndex}
                        type={this.props.isLocked ? "none" : "resize"}
                    />
                    {Array(columnCount)
                        .fill(true)
                        .map((e, i) => {
                            return (
                                <EventMoveHandle
                                    {...commonEventProps}
                                    column={i + 1}
                                    key={i}
                                    onMouseDown={() => {
                                        this.onMouseDown(
                                            "move",
                                            startIndex + i
                                        );
                                    }}
                                    absoluteColumnIndex={startIndex + i}
                                    type={this.props.isLocked ? "none" : "move"}
                                />
                            );
                        })}

                    <EventResizeHandle
                        {...commonEventProps}
                        column={columnCount + 2}
                        side={"right"}
                        onMouseDown={() => {
                            this.onMouseDown("resizeRight", endIndex + 1);
                        }}
                        type={this.props.isLocked ? "none" : "resize"}
                        absoluteColumnIndex={endIndex + 1}
                    />
                </EventResizeGrid>
                <EventFace
                    colour={event.colour}
                    selected={this.props.selected}
                    duration={this.props.duration}
                >
                    <EventHeader selected={this.props.selected}>
                        <HeaderText>
                            {job_id !== "" && (
                                <Chip
                                    label="CREATED"
                                    style={{
                                        height: "auto",
                                        fontSize: "11px",
                                        padding: "2px",
                                        background: "green",
                                        color: "white",
                                    }}
                                />
                            )}{" "}
                            {job_name}
                        </HeaderText>
                        <HeaderLink column={5}>
                            <StyledButton
                            disabled={this.props.canDelete===false}
                                color="inherit"
                                selected={this.props.selected}
                                onClick={() => {
                                    this.props.removeEvent(event.uid);
                                }}
                            >
                                <ClearIcon color="inherit" />
                            </StyledButton>
                        </HeaderLink>
                        <HeaderLink column={3}>
                            <StyledButton
                            disabled={this.props.canUpdate===false}
                                color="inherit"
                                selected={this.props.selected}
                                onClick={() => {
                                    this.props.editEvent(
                                        this.props.track_id,
                                        eventInfo
                                    );
                                }}
                            >
                                <EditIcon color="inherit" />
                            </StyledButton>
                        </HeaderLink>
                        <HeaderLink column={4}>
                            <StyledButton
                            disabled={this.props.canUpdate===false}
                                color="inherit"
                                selected={this.props.selected}
                                onClick={() => {
                                    this.props.setCopyPasteEvent(eventInfo);
                                }}
                            >
                                <CopyIcon color="inherit" />
                            </StyledButton>
                        </HeaderLink>
                        <HeaderLink column={2}>
                            <Link
                                style={{ color: "inherit" }}
                                to={{
                                    pathname: `/job-pack-posting/jobpacks/active/year/month/uid`,
                                    state: { posting: eventInfo },
                                }}
                            >
                                <StyledButton
                                    disabled={this.props.canCreate===false}
                                    color="inherit"
                                    selected={this.props.selected}
                                >
                                    <AddIcon color="inherit" />
                                </StyledButton>
                            </Link>
                        </HeaderLink>
                    </EventHeader>
                    <EventInfo rowCount={2}>
                        <PersonnelRow
                            jobTitle={"Location: "}
                            jobPersonnel={address || ""}
                            rowIndex={managerRowStart}
                        />
                        <PersonnelRow
                            jobTitle={"Supervisor: "}
                            jobPersonnel={
                                assigned_supervisor
                                    ? assigned_supervisor.user_name
                                    : ""
                            }
                            rowIndex={2}
                        />
                        <PersonnelRow
                            jobTitle={"Crew: "}
                            jobPersonnel={
                                assigned_operatives
                                    ? this.getName(
                                          assigned_operatives,
                                          "user_name"
                                      )
                                          .toString()
                                          .replace(/,/g, ", ")
                                    : ""
                            }
                            rowIndex={3}
                        />
                        <PersonnelRow
                            jobTitle={"Vehicles: "}
                            jobPersonnel={
                                job_vehicles
                                    ? this.getName(job_vehicles, "machine_reg")
                                          .toString()
                                          .replace(/,/g, ", ")
                                    : ""
                            }
                            rowIndex={4}
                        />
                        <PersonnelRow
                            jobTitle={"Equipment: "}
                            jobPersonnel={
                                job_equipment
                                    ? this.getName(job_equipment, "name")
                                          .toString()
                                          .replace(/,/g, ", ")
                                    : ""
                            }
                            rowIndex={5}
                        />
                    </EventInfo>
                </EventFace>
            </EventContainer>
        );
    }
}

export default hot(module)(
    React.memo(
        connect(
            (store, props) => {
                return {
                    jobpostingProfile: selectJobpostingProfile(props.event.uid)(
                        store
                    ),
                    clickedEventSegment: selectClickedEventSegment(store),
                    isLocked: selectIsLocked(store),
                    canDelete:canDelete(store),canCreate:canCreate(store),canUpdate:canUpdate(store)
                };
            },
            {
                setClickedEventSegment,
                setSelectedJobpostingID,
                navigateTo,
                removeEvent,
                setCopyPasteEvent,
            }
        )(Event)
    )
);
